import { Injectable } from '@angular/core';
import { BaseStorageProvider } from '../base-storage.service';

@Injectable({ providedIn: 'root' })
export class SessionStorageService extends BaseStorageProvider {
  protected storage = sessionStorage;
}
